import { APIEndpoints } from "../../constants";
import { APIPost, APIResponse } from "../api/common.service";
import { LoginCredentials, LoginResponseData } from "../../types";

/**
 * Login endpoint with email or user_id, password, and role payload.
 */
export function LoginUsingEmail(
  body: LoginCredentials
): Promise<APIResponse<LoginResponseData>> {
  const value = (body.email || body.user_id || "").trim();
  const payload: Record<string, unknown> = {
    password: body.password,
    role: body.role,
  };

  if (value.includes("@")) {
    payload.email = value;
  } else {
    payload.user_id = value;
  }

  return APIPost<LoginResponseData>(
    APIEndpoints.LoginUsingEmail,
    undefined,
    undefined,
    payload
  );
}
